module.exports = __webpack_public_path__ + "media/views/request_offer/images/envelope-40fb252cb8dc380608e2462cfbd12158.svg";